(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /* "08:00-17:00" to [480, 1020]. Anything it cannot read returns null, which
     is treated as closed rather than as an error, so a typo in the theme
     editor costs a line of copy and not a broken page. */
  function span(raw) {
    if (!raw) return null;
    var m = String(raw).match(/^\s*(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})\s*$/);
    if (!m) return null;
    var o = +m[1] * 60 + +m[2];
    var c = +m[3] * 60 + +m[4];
    return c > o ? [o, c] : null;
  }

  function hhmm(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
  }

  /* THE CLOCK IS CAPE TOWN'S, NOT THE VISITOR'S. The question this line
     answers is whether somebody is in the workshop, so reading the browser's
     own clock would be wrong for every visitor outside South Africa and, worse,
     wrong in a way that looks right. Intl does the whole job including the
     weekday, so there is no offset arithmetic to get wrong. */
  function sast() {
    var p = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Africa/Johannesburg',
      weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var out = {};
    p.forEach(function (x) { out[x.type] = x.value; });
    var idx = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(out.weekday);
    if (idx < 0) return null;
    var h = parseInt(out.hour, 10);
    return { day: idx, mins: (h === 24 ? 0 : h) * 60 + parseInt(out.minute, 10) };
  }

  function state(root) {
    var week = span(root.dataset.pcWeek);
    var sat = span(root.dataset.pcSat);
    var sun = span(root.dataset.pcSun);
    /* index 0 is Sunday, to match Date's own day numbering */
    var sched = [sun, week, week, week, week, week, sat];
    if (!sched.some(Boolean)) return null;

    var now = sast();
    if (!now) return null;

    var today = sched[now.day];
    if (today && now.mins >= today[0] && now.mins < today[1]) {
      return { open: true, text: 'The workshop is open until ' + hhmm(today[1]) + '.' };
    }
    if (today && now.mins < today[0]) {
      return { open: false, text: 'Closed now. The workshop opens at ' + hhmm(today[0]) + '.' };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7;
      if (sched[d]) {
        var when = i === 1 ? 'tomorrow' : 'on ' + DAY[d];
        return { open: false, text: 'Closed now. Open again ' + when + ' at ' + hhmm(sched[d][0]) + '.' };
      }
    }
    return null;
  }

  /* ?product=Double+Arch+Steel+Door becomes a visible, removable line on the
     form and a contact[Product] value in the email.

     Liquid cannot read query parameters on this store, which is why this is
     script and not markup. Everything about it fails to NOTHING: no parameter,
     no script, or a value that does not survive the checks below all leave the
     form exactly as it renders for a visitor who came here directly. */
  function carryProduct(root) {
    var field = root.querySelector('[data-pc-product]');
    var row = root.querySelector('[data-pc-about]');
    if (!field || !row) return;

    var raw;
    try {
      raw = new URLSearchParams(window.location.search).get('product');
    } catch (e) { return; }
    if (!raw) return;

    /* A product title, not free text. Anything with markup, a newline or a
       silly length is somebody testing what this field accepts, so it is
       dropped rather than cleaned: the page is no worse off without it. */
    var name = String(raw).replace(/\s+/g, ' ').trim();
    if (!name || name.length > 90 || /[<>{}]/.test(name)) return;

    field.value = name;
    root.querySelector('[data-pc-about-name]').textContent = name;
    row.hidden = false;

    var clear = root.querySelector('[data-pc-about-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        field.value = '';
        row.hidden = true;
        var first = root.querySelector('.pc-input');
        if (first) first.focus();
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-pc]');
    if (!roots.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      carryProduct(root);
      /* The status line ships hidden and empty. It is only ever filled in from
         a resolved state, so every failure path leaves the page silent about
         the workshop instead of guessing at it. */
      var box = root.querySelector('[data-pc-status]');
      if (box) {
        var st = null;
        try { st = state(root); } catch (e) { st = null; }
        if (st) {
          root.querySelector('[data-pc-status-text]').textContent = st.text;
          box.classList.toggle('is-shut', !st.open);
          box.hidden = false;
        }
      }

      /* The load sequence runs on the next frame so the first paint already
         has the resting styles applied and the transition has somewhere to
         come from. */
      if (reduce) {
        root.classList.add('is-in');
      } else {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { root.classList.add('is-in'); });
        });
      }

      var rev = root.querySelectorAll('.pc-reveal');
      if (!rev.length) return;
      if (reduce || !('IntersectionObserver' in window)) {
        rev.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-anatomy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var roots = document.querySelectorAll('.pa-anatomy');
    if (!roots.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var revEls = document.querySelectorAll('.pa-anatomy .pa-reveal');
    if (revEls.length) {
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
        }, { rootMargin: '0px 0px -8% 0px' });
        revEls.forEach(function (el) { io.observe(el); });
      } else {
        revEls.forEach(function (el) { el.classList.add('is-in'); });
      }
    }

    roots.forEach(function (root) {
      var anatomy = root.querySelector('.anatomy');
      var track = root.querySelector('.anat-track');
      var stage = root.querySelector('.anat-stage');
      if (!anatomy || !track || !stage) return;
      // Reduced motion still falls back to the flat door plus the plain list.
      if (reduce) {
        anatomy.classList.add('anat-flat');
        stage.classList.add('is-live', 'is-static');
        return;
      }
      anatomy.classList.remove('anat-flat');
      stage.classList.remove('is-static');
      stage.classList.add('is-live');

      var n = root.querySelectorAll('.anat-note').length;
      if (!n) return;

      /* WHICH LAYOUT. Measured, never guessed at a breakpoint.
         The margin-note diagram needs a note column on both sides of the door,
         and whether that fits depends on how wide THIS product's door is, not
         just on the viewport: a pair is twice the width of a single at the same
         height, so the double broke at 1024x1366 while the single was fine at
         exactly the same size. One breakpoint cannot serve both, and a
         breakpoint picked per product is a rule nobody can see. So the actual
         numbers are compared, and re-compared on resize and rotate. */
      var NOTE_COL = 340;                 // keep in step with --anat-side
      var frameEl = root.querySelector('.anat-frame');   // NOT 'frame': that is the rAF callback below
      function fit() {
        var ar = parseFloat(getComputedStyle(frameEl).getPropertyValue('--ar')) || 0.52;
        var doorW = Math.min(window.innerHeight * 0.88, 980) * ar;
        var room = document.documentElement.clientWidth - doorW;
        stage.classList.toggle('is-roomy', room >= 2 * NOTE_COL);
      }
      fit();
      var fitPending = 0;
      window.addEventListener('resize', function () {
        if (fitPending) return;
        fitPending = window.requestAnimationFrame(function () { fitPending = 0; fit(); });
      }, { passive: true });

      /* One bucket per callout. A callout owns its leader path, its dot, its note
         and its phone caption, and all four move together on one number, so they
         are grouped once here rather than re-queried and re-parsed every frame. */
      var groups = [];
      for (var g = 0; g < n; g++) groups.push([]);
      Array.prototype.forEach.call(root.querySelectorAll('[data-i]'), function (el) {
        var i = parseInt(el.getAttribute('data-i'), 10);
        if (i >= 0 && i < n) groups[i].push(el);
      });
      /* Class toggled, because these two SWAP rather than crossfade: the phone
         caption slot shows one callout at a time. Phones are off in V8.9 (see the
         stylesheet), so this only keeps that layout intact for later. */
      var swap = root.querySelectorAll('.anat-cap');

      /* hold on the first and last callout for a beat, so neither is clipped by
         the moment of pinning or the moment of release */
      var LEAD = 0.08;
      /* How far, in callouts, one stop's light still carries. Above 1.0 on
         purpose: at 0.85 a callout's influence died before its neighbour's
         began to register, so the handoff read as a swap rather than a fade.
         The next badge now begins to lift while the one before it is still at
         about 99%, and the two cross at 60/60 rather than 40/40. */
      var REACH = 1.15;
      /* a mouse wheel arrives in ~100px notches, so a raw 1:1 mapping still
         visibly steps. This is what turns the notches into travel. */
      var EASE = 0.18;

      var cur = 0, painted = -1, last = -1, raf = 0, running = false, prevT = 0;

      function measure() {
        var rect = track.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var p = total > 0 ? (-rect.top) / total : 0;
        var q = (p - LEAD) / (1 - LEAD * 2);
        return (q < 0 ? 0 : q > 1 ? 1 : q) * (n - 1);
      }

      function paint(pos) {
        for (var i = 0; i < n; i++) {
          var d = Math.abs(pos - i) / REACH;
          /* Raised cosine, not smoothstep. Smoothstep flattens both TAILS, so a
             callout was mathematically fading long before it was visibly fading
             and the crossover collapsed into a swap. This is flat at the peak
             and at the tail but linear-ish through the middle, which is exactly
             where the handoff happens. Two notes at 60% is not muddy here: they
             sit at different heights and usually on opposite sides. */
          var w = d >= 1 ? 0 : 0.5 * (1 + Math.cos(Math.PI * d));
          var grp = groups[i];
          for (var j = 0; j < grp.length; j++) grp[j].style.setProperty('--w', w.toFixed(3));
        }
        var idx = Math.round(pos);
        if (idx !== last) {
          last = idx;
          Array.prototype.forEach.call(swap, function (el) {
            el.classList.toggle('is-current', parseInt(el.getAttribute('data-i'), 10) === idx);
          });
        }
      }

      function frame(t) {
        var dt = prevT ? Math.min(64, t - prevT) : 16.7;
        prevT = t;
        var to = measure();
        /* frame rate independent, so a 120Hz screen does not settle twice as fast */
        cur += (to - cur) * (1 - Math.pow(1 - EASE, dt / 16.7));
        if (Math.abs(to - cur) < 0.0008) cur = to;
        if (cur !== painted) { paint(cur); painted = cur; }
        raf = window.requestAnimationFrame(frame);
      }

      function start() { if (!running) { running = true; prevT = 0; raf = window.requestAnimationFrame(frame); } }
      function stop() { if (running) { running = false; window.cancelAnimationFrame(raf); } }

      cur = measure();
      paint(cur);
      painted = cur;

      /* The old loop called getBoundingClientRect every frame for the life of the
         page, on a product page about 15000px long, so it forced a layout read 60
         times a second for the ~95% of that page where this module is nowhere near
         the viewport. It only spins while the track is in reach now. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
        }, { rootMargin: '200px 0px 200px 0px' }).observe(track);
      } else {
        start();
      }
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-closing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.pa-closing .pa-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.pa-faq [data-acc]').forEach(function (acc) {
      var items = acc.querySelectorAll('.acc__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.acc__btn');
        var panel = item.querySelector('.acc__panel');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (it) {
            it.classList.remove('is-open');
            var p = it.querySelector('.acc__panel');
            var b = it.querySelector('.acc__btn');
            if (p) p.style.maxHeight = null;
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.pa-gallery .pa-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-heritage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.pa-heritage .pa-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('.pdp-alu');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function seam() {
      var strip = root.querySelector('.pa-strip');
      if (!strip) return;
      var h = strip.getBoundingClientRect().height;
      if (h > 0) root.style.setProperty('--strip-h', h + 'px');
    }
    seam();
    window.addEventListener('load', seam);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(seam, 120); });

    var doorImgs = root.querySelectorAll('.pa-door__img');
    root.querySelectorAll('[data-paview]').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = b.getAttribute('data-paview') === 'angle' ? 1 : 0;
        doorImgs.forEach(function (im, i) { im.classList.toggle('is-shown', i === idx); });
        root.querySelectorAll('[data-paview]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', String(on));
        });
      });
    });

    function configuratorEl() {
      /* A priced product has a buy form; an enquiry-only one (R 0) has the
         .pfo band instead. Without the fallback the quote buttons found
         nothing and did nothing. */
      var pf = document.querySelector('product-form-component') || document.querySelector('.pfo');
      return pf ? pf.closest('.shopify-section') : null;
    }
    document.querySelectorAll('[data-pa-configure]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var el = configuratorEl();
        if (el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    var rev = root.querySelectorAll('.pa-reveal');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    } else {
      rev.forEach(function (el) { el.classList.add('is-in'); });
    }

    var bar = root.querySelector('[data-pa-sticky]');
    var hero = root.querySelector('.pa-stage');
    if (bar && hero && 'IntersectionObserver' in window) {
      var conf = configuratorEl();
      var heroOut = false, confIn = false;
      function upd() {
        var show = heroOut && !confIn;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
      }
      new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hero);
      if (conf) new IntersectionObserver(function (e) { confIn = e[0].isIntersecting; upd(); }, { threshold: .12 }).observe(conf);
    }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-material"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.pa-material .pa-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('section[data-pao]');
  if (!root) return;

  // Entrance: same IntersectionObserver reveal pattern as pdp-alu-anatomy's .pa-reveal
  // (fade the band in, then unobserve). Reduced-motion gets the static end state.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduceMotion) {
    var pao_io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); pao_io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    pao_io.observe(root);
  } else {
    root.classList.add('is-in');
  }

  var VARIANTS = [];
  try { VARIANTS = JSON.parse(root.querySelector('[data-pao-variants]').textContent); } catch (e) { VARIANTS = []; }

  var idField = root.querySelector('[data-pao-id]');
  var qtyField = root.querySelector('[data-pao-qty-field]');
  var priceEl = root.querySelector('[data-pao-price]');
  var buyBtn = root.querySelector('.pao-buy-button:not(.pao-quote)');
  var cartRow = root.querySelector('[data-pao-cartrow]');
  var quoteBtn = root.querySelector('[data-pao-quoterow]');
  var formComp = root.querySelector('product-form-component');

  var propColour = root.querySelector('[data-pao-prop-colour]');
  var propOpening = root.querySelector('[data-pao-prop-opening]');
  var ralInput = root.querySelector('[data-pao-ral]');
  var bespokePanel = root.querySelector('[data-pao-bespoke-panel]');
  var dimsPanel = root.querySelector('[data-pao-dims]');
  var dimNote = root.querySelector('[data-pao-dim-note]');
  var dimH = root.querySelector('[data-pao-dim-h]');
  var dimW = root.querySelector('[data-pao-dim-w]');

  var openingText = root.getAttribute('data-pao-opening') || '';
  var quoteOnly = root.hasAttribute('data-pao-quote-only');
  var quoteBase = quoteBtn ? (quoteBtn.getAttribute('href') || '').split('?')[0] : '';
  var productTitle = root.getAttribute('data-pao-title') || '';

  // parse standard height x width from "2000 x 900 mm" / "2000 × 900 mm"
  var stdNums = (openingText.match(/\d+/g) || ['2000', '900']);
  var stdH = stdNums[0] || '2000', stdW = stdNums[1] || '900';

  var state = { colour: 'Obsidian Black', size: 'standard', design: '', glazing: '' };

  // variant-axis selections keyed by option position
  var selected = {};
  root.querySelectorAll('[data-pao-opt][aria-pressed="true"]').forEach(function (b) {
    selected[b.getAttribute('data-pao-opt')] = b.getAttribute('data-pao-value');
  });

  function money(cents) {
    var n = Math.round(cents / 100);
    return 'R ' + n.toLocaleString('en-ZA').replace(/,/g, ' ');
  }

  function computeDeltas() {
    if (!VARIANTS.length) return;
    var minAll = Infinity;
    VARIANTS.forEach(function (v) { if (v.price < minAll) minAll = v.price; });
    root.querySelectorAll('[data-pao-opt]').forEach(function (btn) {
      var slot = btn.querySelector('[data-pao-delta]');
      if (!slot) return;
      var pos = btn.getAttribute('data-pao-opt');
      var val = btn.getAttribute('data-pao-value');
      var key = 'o' + pos, min = Infinity;
      VARIANTS.forEach(function (v) { if (v[key] === val && v.price < min) min = v.price; });
      var d = (min === Infinity) ? 0 : (min - minAll);
      slot.textContent = d > 0 ? ('+ ' + money(d)) : '';
    });
  }

  function matchVariant() {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if ((selected['1'] == null || v.o1 === selected['1']) &&
          (selected['2'] == null || v.o2 === selected['2']) &&
          (selected['3'] == null || v.o3 === selected['3'])) {
        return v;
      }
    }
    return null;
  }

  function currentDesign() {
    var d = root.querySelector('.pao-design-choice[aria-pressed="true"]');
    if (d) return d.getAttribute('data-pao-value');
    var s = root.querySelector('[data-pao-sum-design]');
    return s ? s.textContent : '';
  }

  function currentGlazing() {
    var g = root.querySelector('.pao-glaze[aria-pressed="true"]');
    return g ? g.getAttribute('data-pao-value') : '';
  }

  /* QUOTE ONLY: the configuration becomes the contact page's "About" line.
     That page DROPS a ?product= value over 90 characters (it treats it as
     somebody testing the field), so the parts go in order of what a quote
     needs most and the least important is left off rather than overflowing:
     model, design, glazing, a non-standard size, then colour. */
  function quoteSummary() {
    var parts = [productTitle, currentDesign(), currentGlazing()];
    if (state.size !== 'standard') {
      var h = (dimH && dimH.value) ? dimH.value : stdH;
      var w = (dimW && dimW.value) ? dimW.value : stdW;
      parts.push(h + ' x ' + w + ' mm');
    }
    parts.push(propColour ? propColour.value : state.colour);
    var out = '';
    parts.forEach(function (p) {
      p = String(p || '').replace(/\s+/g, ' ').replace(/[<>{}]/g, '').trim();
      if (!p) return;
      var next = out ? out + ', ' + p : p;
      if (next.length <= 90) out = next;
    });
    return out;
  }

  function syncQuote() {
    if (quoteOnly || state.size === 'custom') updateQuoteHref();
  }

  function updateQuoteHref() {
    if (!quoteBtn) return;
    if (quoteOnly) {
      quoteBtn.setAttribute('href', quoteBase + '?product=' + encodeURIComponent(quoteSummary()));
      return;
    }
    var lines = [
      'I would like a quote for a custom-size door.',
      '',
      'Model: ' + productTitle,
      'Design: ' + currentDesign(),
      'Colour: ' + (propColour ? propColour.value : state.colour),
      'Glazing: ' + currentGlazing(),
      'Requested size: ' + (dimH && dimH.value ? dimH.value : stdH) + ' x ' + (dimW && dimW.value ? dimW.value : stdW) + ' mm',
      '',
      'Standard for this model is ' + openingText + '.'
    ];
    var href = 'mailto:sales@ironstone.co.za?subject=' + encodeURIComponent('Custom door enquiry: ' + productTitle) +
      '&body=' + encodeURIComponent(lines.join('\n'));
    quoteBtn.setAttribute('href', href);
  }

  function setEnquiry(on) {
    if (quoteOnly) on = true;
    if (cartRow) cartRow.hidden = on;
    if (quoteBtn) quoteBtn.hidden = !on;
    if (on) updateQuoteHref();
  }

  function refresh() {
    var v = matchVariant();
    root.querySelectorAll('[data-pao-rowval]').forEach(function (rv) {
      var pos = rv.getAttribute('data-pao-rowval');
      if (selected[pos]) rv.textContent = selected[pos];
    });
    var sd = root.querySelector('[data-pao-sum-design]');
    if (sd && currentDesign()) sd.textContent = currentDesign();
    var sg = root.querySelector('[data-pao-sum-glazing]');
    // glazing is the option that varies with price; find its selected value
    var glazeBtn = root.querySelector('.pao-glaze[aria-pressed="true"]');
    if (sg && glazeBtn) sg.textContent = glazeBtn.getAttribute('data-pao-value');

    if (v) {
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.img) { var f = root.querySelector('[data-pao-view="front"]'); if (f) f.src = v.img; }
      if (v.imgAngle) { var a = root.querySelector('[data-pao-view="angle"]'); if (a) a.src = v.imgAngle; }
      if (buyBtn) {
        buyBtn.disabled = !v.avail;
        var txt = buyBtn.querySelector('.add-to-cart-text__content span span') || null;
        if (txt) txt.textContent = v.avail ? 'Add to cart' : 'Unavailable';
      }
    }
    syncQuote();
  }

  // variant-axis controls (Design, Glazing)
  root.querySelectorAll('[data-pao-opt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = btn.getAttribute('data-pao-opt');
      var val = btn.getAttribute('data-pao-value');
      selected[pos] = val;
      root.querySelectorAll('[data-pao-opt="' + pos + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      refresh();
    });
  });

  // colour (order note)
  var colourVal = root.querySelector('[data-pao-colour-val]');
  var sumColour = root.querySelector('[data-pao-sum-colour]');
  root.querySelectorAll('[data-pao-colour]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var name = btn.getAttribute('data-pao-colour');
      state.colour = name;
      root.querySelectorAll('[data-pao-colour]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      var isBespoke = /bespoke/i.test(name);
      if (bespokePanel) bespokePanel.classList.toggle('is-visible', isBespoke);
      var label = isBespoke ? (ralInput && ralInput.value.trim() ? 'Bespoke, ' + ralInput.value.trim() : 'Bespoke') : name;
      if (colourVal) colourVal.textContent = label;
      if (sumColour) sumColour.textContent = label;
      if (propColour) propColour.value = label;
      syncQuote();
    });
  });
  if (ralInput) {
    ralInput.addEventListener('input', function () {
      var label = ralInput.value.trim() ? 'Bespoke, ' + ralInput.value.trim() : 'Bespoke';
      if (colourVal) colourVal.textContent = label;
      if (sumColour) sumColour.textContent = label;
      if (propColour) propColour.value = label;
      syncQuote();
    });
  }

  // opening (order note + enquiry routing)
  var openingVal = root.querySelector('[data-pao-opening-val]');
  var sumOpening = root.querySelector('[data-pao-sum-opening]');
  function applyOpening() {
    var mode = state.size;
    var showDims = (mode === 'adjust' || mode === 'custom');
    if (dimsPanel) dimsPanel.classList.toggle('is-visible', showDims);
    var h = (dimH && dimH.value !== '') ? Number(dimH.value) : Number(stdH);
    var w = (dimW && dimW.value !== '') ? Number(dimW.value) : Number(stdW);
    var validNums = isFinite(h) && h > 0 && isFinite(w) && w > 0;
    var within = validNums && Math.abs(h - Number(stdH)) <= 200 && Math.abs(w - Number(stdW)) <= 200;
    // Custom is always an enquiry; an Adjust that exceeds 200 mm also becomes an enquiry.
    var enquiry = (mode === 'custom') || (mode === 'adjust' && !within);

    var label;
    if (mode === 'standard') label = 'Standard, ' + openingText;
    else if (mode === 'adjust' && within) label = 'Adjusted, ' + h + ' x ' + w + ' mm';
    else label = 'By quote, ' + h + ' x ' + w + ' mm';
    if (openingVal) openingVal.textContent = label;
    if (sumOpening) sumOpening.textContent = label;
    if (propOpening) propOpening.value = label;

    if (dimNote) {
      dimNote.classList.toggle('is-visible', showDims);
      dimNote.classList.toggle('is-quote', enquiry);
      if (mode === 'adjust' && within) {
        dimNote.textContent = 'Within 200 mm of standard (' + openingText + '), at the same price. Final dimensions are confirmed on the workshop drawing.';
      } else if (mode === 'adjust' && !within) {
        dimNote.textContent = validNums
          ? 'That is more than 200 mm from the standard ' + openingText + ', so it is quoted individually. Send it as an enquiry and we will price it.'
          : 'Enter a valid height and width. Sizes more than 200 mm from standard are quoted individually.';
      } else if (mode === 'custom') {
        dimNote.textContent = 'Custom openings are quoted individually. Send your sizes and we will come back with a price.';
      } else {
        dimNote.textContent = '';
      }
    }
    setEnquiry(enquiry);
  }
  root.querySelectorAll('[data-pao-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.size = btn.getAttribute('data-pao-size');
      root.querySelectorAll('[data-pao-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      applyOpening();
    });
  });
  if (dimH) dimH.addEventListener('input', applyOpening);
  if (dimW) dimW.addEventListener('input', applyOpening);

  // preview view switch
  root.querySelectorAll('[data-pao-vbtn]').forEach(function (b) {
    b.addEventListener('click', function () {
      var view = b.getAttribute('data-pao-vbtn');
      root.querySelectorAll('[data-pao-vbtn]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      root.querySelectorAll('.pao-preview__img').forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-pao-view') === view);
      });
    });
  });

  // quantity
  var qty = 1;
  var qout = root.querySelector('[data-pao-qout]');
  function setQty(n) {
    qty = Math.max(1, n);
    if (qout) qout.textContent = qty;
    if (qtyField) qtyField.value = qty;
    if (formComp) formComp.setAttribute('data-quantity-default', String(qty));
  }
  var qm = root.querySelector('[data-pao-qminus]');
  var qp = root.querySelector('[data-pao-qplus]');
  if (qm) qm.addEventListener('click', function () { setQty(qty - 1); });
  if (qp) qp.addEventListener('click', function () { setQty(qty + 1); });

  // init dim fields to standard
  if (dimH) dimH.value = stdH;
  if (dimW) dimW.value = stdW;

  computeDeltas();
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-range"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.pa-range .pa-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-renders"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.pa-renders').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.par__item'));
      var wrap = root.querySelector('[data-par-more]');
      var btn = root.querySelector('[data-par-btn]');
      var count = root.querySelector('[data-par-count]');
      var step = parseInt(root.getAttribute('data-par-step'), 10) || 10;
      if (!items.length || !wrap || !btn) return;

      var shown = 0;
      function render() {
        items.forEach(function (el, i) {
          if (i < shown) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
        });
        var left = items.length - shown;
        if (left > 0) {
          wrap.hidden = false;
          if (count) count.textContent = '(' + left + ')';
        } else {
          wrap.hidden = true;
        }
      }
      function reveal() {
        var from = shown;
        shown = Math.min(items.length, shown + step);
        render();
        // let the newly shown items animate in even though they were never
        // observed while hidden
        for (var i = from; i < shown; i++) observe(items[i]);
      }

      var io = null;
      if ('IntersectionObserver' in window && !reduce) {
        io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px' });
      }
      function observe(el) {
        if (!el) return;
        if (io) { io.observe(el); } else { el.classList.add('is-in'); }
      }

      btn.addEventListener('click', function () {
        var first = items[shown];
        reveal();
        if (first) first.scrollIntoView({ block: 'nearest' });
      });

      shown = 0;
      reveal();
    });

    // any other reveal targets outside the batching (none today, kept safe)
    document.querySelectorAll('.pa-renders .par-reveal:not(.par__item)').forEach(function (el) {
      el.classList.add('is-in');
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-alu-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.pa-reviews [data-revpause]').forEach(function (btn) {
      var root = btn.closest('.pa-reviews');
      var wall = root ? root.querySelector('[data-revwall]') : null;
      if (!wall) return;
      btn.addEventListener('click', function () {
        var paused = wall.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', String(paused));
        btn.textContent = paused ? 'Play reviews' : 'Pause reviews';
      });
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-furn-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('section[data-pfo]');
  if (!root) return;

  var colourLabel = root.querySelector('[data-pfo-colour-label]');
  var propColour = root.querySelector('[data-pfo-prop-colour]');
  var ralInput = root.querySelector('[data-pfo-ral]');
  var bespokePanel = root.querySelector('[data-pfo-bespoke-panel]');

  root.querySelectorAll('[data-pfo-colour]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var name = btn.getAttribute('data-pfo-colour');
      root.querySelectorAll('[data-pfo-colour]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      var isBespoke = /bespoke/i.test(name);
      if (bespokePanel) bespokePanel.classList.toggle('is-visible', isBespoke);
      var label = isBespoke ? (ralInput && ralInput.value.trim() ? 'Bespoke, ' + ralInput.value.trim() : 'Bespoke') : name;
      if (colourLabel) colourLabel.textContent = label;
      if (propColour) propColour.value = label;
    });
  });

  if (ralInput) {
    ralInput.addEventListener('input', function () {
      var label = ralInput.value.trim() ? 'Bespoke, ' + ralInput.value.trim() : 'Bespoke';
      if (colourLabel) colourLabel.textContent = label;
      if (propColour) propColour.value = label;
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
